function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56"
}, props), React.createElement("path", {
  d: "M0 0h26v26H0zm0 30h26v26H0zm30 0h26v26H30zM55.9 0h-26v26.1H56V0zM50 20H36V6h14z",
  fill: "#828282"
})));